import React from "react";
import SearchList from "./SearchList";
import useViewport from "../Utils/useViewPort"
import MobileSearchList from "./MobileSearchList";

class SearchView extends React.Component {

  constructor(props) {
    super(props);
    this.state = { keySearch: null, search_list: [], searchActive: false, resultShow: false };
  }

  componentDidMount() {

    const keyS = localStorage.getItem("keySearch");
    const list = JSON.parse(localStorage.getItem("search_list"));

    console.log(list)
    if (keyS && list) {
      console.log(list)
      this.setState({ keySearch: keyS });
      this.setState({ search_list: list});
      this.setState({ resultShow: true })
      if (list.length > 0) {
        this.setState({ searchActive: true })
      }
    } else{
      this.setState({searchActive: false})
      this.setState({resultShow: false})
    }
    console.log("search vewi moved");
  }


  componentWillUnmount() {
    localStorage.removeItem("key");
    localStorage.removeItem("search_list");
    this.setState({searchActive: false})
    this.setState({resultShow: false})
    console.log("unmounted")
  }


  render() {
    const { keySearch, search_list } = this.state;
    return (
      <>
        <div className="search-mobile-view">
          {this.state.resultShow && <h3>Keyword: {keySearch}</h3>}
          {this.state.resultShow && (<>
            {this.state.searchActive && (
              <>
                < MobileSearchList slist={search_list} />
              </>
            )}
            {!this.state.searchActive && (<><h3>NO result</h3></>)}
          </>
          )}
          {!this.state.resultShow && <SearchList />}
        </div>
        {/* {!keySearch && <Footer />} */}
        {/* {search_list === null && <h4>No content maching</h4>} */}
      </>
    );
  }
}

export default SearchView;
